module.exports = __webpack_public_path__ + "assets/img/box7_img2.e0416afe.png";